import * as StM from '../../models/store';
import BaseReducer from '../baseReducer';
import * as _ from 'lodash';

export default class EditCoachFeeTierDialogReducer extends BaseReducer {
    static handle(state: StM.IEditCoachFeeTierDialogStoreState = new StM.EditCoachFeeTierDialogStoreState(), action: any): StM.IEditCoachFeeTierDialogStoreState {
        switch (action.type) {
            case 'Dialogs/Admin/EditCoachFeeTier/Open': {
                return <StM.IEditCoachFeeTierDialogStoreState>_.assign({}, state, { isOpened: true, id: action.id });
            }
            case 'Dialogs/Admin/EditCoachFeeTier/Close': {
                return <StM.IEditCoachFeeTierDialogStoreState>_.assign({}, state, { isOpened: false });
            }
            default: {
                return state;
            }
        }
    }
}
